import React from "react";
import { atom, selector, useRecoilValue, useSetRecoilState } from "recoil";
import { userState } from ".";
import { i18n } from "../framework/i18n";
import { ImageUtils } from "../framework/utils";
import { UserSetting } from "../models/UserSetting";
import apiService from "../services/api";
import { AvatarInfoType, useAvatar } from "./auth";

export const userSettingTxAtom = atom<number>({
    key: 'userSettingTxAtom',
    default: 0
})

export const userSettingDefault: UserSetting = {
    id: 0,
    insertUser: '',
    insertDate: null,
    updateUser: '',
    updateDate: null,
    language: '',
    username: '',
    uiConfig: '',
    avatar: null,
    fileEncoded: '',
    newsConsent: false,
    applicationConsent: false,
    notifications: '',
    categSelected: '',
    immediates: '',
    marketingConsent: null,
    carouselDisabled: false
}

export const useLanguageFromSettings = () => { 
    const userSetting = useRecoilValue(userSettingSelected)

    React.useEffect(() => {
        i18n.changeLanguage(userSetting.language)        
    }, [userSetting])
}

export const userSettingSelected = selector({
    key: 'userSettingSelected',
    get: async ({ get }) => {
        const user = get(userState)
        // console.log({user})
        let rv = userSettingDefault
        if (user && user.setting) {
            return user.setting
        }
        return rv;
    }
})

export const useUserSettings: () => [UserSetting, (us: UserSetting) => Promise<void>] = () => {
    const us = useRecoilValue(userSettingSelected)
    const setUserSettingsTx = useSetRecoilState(userSettingTxAtom)
    const setUserSettings = async (us: UserSetting) => {
        await apiService.saveUserSetting(us)
        setUserSettingsTx(tx => tx + 1)
    }
    return ([us, setUserSettings])
}

export const userImageDataSelector = selector({
    key: 'userImageDataUrl',
    get: async ({ get }) => {
        let result: string = ''
        get(userSettingTxAtom)
        const user = get(userState)
        //const us = get(userSettingSelected)
        const us = await apiService.getUserSetting(user?.name!)
        if (us && us.fileEncoded) {
            //let base64 = BrowserUtils.convertArrayToBase64(us.avatar)
            result = ImageUtils.fromBase64ToDataUrl(us.fileEncoded, 'png')
        }
        return result;
    }
})

export const useAvatarInfo: () => AvatarInfoType = () => {
    const image = useRecoilValue(userImageDataSelector)
    const rv = useAvatar(image)
    return rv
}
